// hooks/useProducts.js — хук для отримання товарів
//
// Хук — це функція яка інкапсулює логіку.
// Замість того щоб писати fetch() в кожному компоненті,
// просто викликаємо: const { products, loading } = useProducts()

import { useState, useEffect } from 'react';
import { productsApi } from '../api';

export function useProducts(category) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    productsApi.getAll(category)
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [category]); // перезавантажує при зміні категорії

  return { products, loading, error };
}
